// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"styles_breadcrumbs__fGd8Z","link":"styles_link__vTi6C","icon":"styles_icon__5YM4I","sep":"styles_sep__ZunZ8"};